export default "__VITE_ASSET__vWp7iWdH__"